import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { bindActionCreators } from 'redux'

import ContentHeader from 'component/utils/ContentHeader'
import Grid from 'component/utils/Grid'
import Col from 'component/utils/Col'
import Pagination from 'component/pagination/Pagination'
import Table from 'component/rotativeInventory/Table'
import FilterForm from 'component/rotativeInventory/FilterForm'
import Breadcrumb from 'component/Breadcrumb'

import _ from 'lodash'

import columns from 'component/rotativeInventory/columns'

import * as rotativeInventoryActions from 'action/rotativeInventory'
import * as reportActions from 'action/report'

class RotativeInventory extends Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    logout: PropTypes.func.isRequired,
    menu: PropTypes.object.isRequired,
    count: PropTypes.number.isRequired,
    current: PropTypes.number.isRequired,
    pages: PropTypes.number.isRequired,
    translate: PropTypes.func.isRequired,
    fetchRotativeInventory: PropTypes.func.isRequired,
    rotativeInventoryList: PropTypes.array.isRequired,
    handleResize: PropTypes.func,
    fetchReports: PropTypes.func.isRequired,
  }

  state = {
    filters: {},
    topMargin: 0,
    showTable: false,
    includeLot: false,
    includeProvider: false,
    paginationStyle: {},
  }

  componentDidMount() {
    this.setState({ showTable: false })

    window.addEventListener('resize', this.handleResize)
    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll = () => {
    const scroll = document.documentElement.scrollLeft

    const screen = window.innerWidth
    const content = document.body.scrollWidth
    const maxScroll = content - screen

    if (scroll < maxScroll) {
      this.setState({
        paginationStyle: {
          marginLeft: scroll,
          marginRight: -scroll,
        },
      })
    }
  }

  columnsToRender = () => {
    const { includeLot, includeProvider } = this.state

    columns.map((column) => {
      switch (column.field) {
        case 'dsBranch':
          column.render = this.renderBranchColumn()
          break

        case 'section':
          column.render = this.renderSectionColumn()
          break

        case 'dsLot':
          column.render = includeLot
          break

        case 'provider':
          column.render = includeProvider
          break

        default:
          break
      }
    })
  }

  handleFetchRotativeInventory = async (filters = {}) => {
    const {
      auth: { user },
      fetchRotativeInventory,
    } = this.props

    await this.setState({ filters, showTable: true })

    this.handleResize()

    await this.columnsToRender()

    fetchRotativeInventory(user.dsToken, filters)
  }

  handlePagination = (page = 1) => {
    const { filters } = this.state

    const params = {
      ...filters,
      page,
    }

    this.handleFetchRotativeInventory(params)
  }

  handleResize = () => {
    const { topMargin } = this.state

    if (!_.isEmpty(this.refs) && window.innerWidth > 768) {
      const { header } = this.refs
      const { filter } = this.refs
      const { table } = this.refs
      const topHeight = header.clientHeight + filter.clientHeight

      if (table) table.style.paddingTop = `${topHeight}px`

      if (topMargin !== topHeight) {
        this.setState({ topMargin: topHeight })
      }
    }
  }

  changeIncludeLot = (e) => {
    this.setState({ includeLot: e.target.checked })
  }

  changeIncludeProvider = (e) => {
    this.setState({ includeProvider: e.target.checked })
  }

  renderBreadcrumb = () => {
    const { translate } = this.props

    const steps = [
      { link: '/', title: translate('mobile.home') },
      { title: translate('mobile.irc-configurations') },
      { link: '/irc-menus', title: translate('mobile.reports') },
      { title: translate('rotativeInventory.stockCounting') },
    ]

    return <Breadcrumb steps={steps} />
  }

  renderPagination = () => {
    const { count, current, pages } = this.props

    const { paginationStyle } = this.state

    if (pages < 2) {
      return
    }

    return (
      <Col
        className='align-center rupture-irc-pagination'
        style={paginationStyle}
      >
        <Pagination
          getPage={this.handlePagination}
          pages={pages}
          current={current}
          count={count}
        />
      </Col>
    )
  }

  renderBranchColumn = () => {
    const { filters } = this.state

    if (filters.idRegions && filters.idRegions.length > 0) {
      return true
    }

    if (filters.idBranches && filters.idBranches.length === 1) {
      return false
    }

    return true
  }

  renderSectionColumn = () => {
    const { filters } = this.state

    if (filters.lsSections && filters.lsSections.length === 1) {
      return false
    }

    return true
  }

  getCsv = () => {
    const {
      fetchReports,
      auth: { user },
    } = this.props

    const { filters } = this.state

    const values = {
      tpReport: 9,
    }

    fetchReports(user.dsToken, values, filters)
  }

  render() {
    const { translate, rotativeInventoryList } = this.props

    const { showTable, includeLot, includeProvider, filters, topMargin } =
      this.state

    const initialValues = {
      listRegionsAndBranchs: [],
    }

    return (
      <div className='rotative-inventory'>
        <div
          ref={'header'}
          className={showTable ? 'rotative-inventory-header' : ''}
        >
          <ContentHeader>{translate('totalAccuracy.title')}</ContentHeader>

          {this.renderBreadcrumb()}
        </div>

        <div
          ref={'filter'}
          className={
            showTable ? 'rotative-inventory-filter padding-bottom-double' : ''
          }
        >
          <Grid fluid>
            <FilterForm
              translate={translate}
              submit={this.handleFetchRotativeInventory}
              changeIncludeLot={this.changeIncludeLot}
              changeIncludeProvider={this.changeIncludeProvider}
              includeProvider={includeProvider}
              className={!showTable ? 'filter-vertical' : ''}
              initialValues={initialValues}
              showTable={showTable}
              getCsv={this.getCsv}
            />
          </Grid>
        </div>

        {showTable && (
          <div className='rotative-inventory-table'>
            <Grid fluid className='no-padding'>
              <div>
                <Table
                  translate={translate}
                  rotativeInventoryList={rotativeInventoryList}
                  includeLot={includeLot}
                  includeProvider={includeProvider}
                  filters={filters}
                  columns={columns}
                  handleResize={this.handleResize}
                  topMargin={topMargin}
                />

                {this.renderPagination()}
              </div>
            </Grid>
          </div>
        )}
      </div>
    )
  }
}

/* istanbul ignore next */
const mapStateToProps = ({ rotativeInventoryReducer, paginateReducer }) => ({
  rotativeInventoryList: rotativeInventoryReducer.records,
  pages: paginateReducer.pages,
  count: paginateReducer.count,
  current: paginateReducer.current,
})

/* istanbul ignore next */
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { ...rotativeInventoryActions, ...reportActions },
    dispatch
  )

const RotativeInventoryTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(RotativeInventory)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RotativeInventoryTranslated)

export { RotativeInventory }
